import { useRef } from 'react'
import { buildMenuEntries } from './buildMenuEntries'
import { FloatingMenuPopover } from './FloatingMenuPopover'
import { useFloatingMenuFocusRestore } from './useFloatingMenuFocusRestore'
import { useFloatingMenuScrollToItem } from './useFloatingMenuScrollToItem'

function FloatingMenuPopup({
  open,
  anchorEl,
  onClose,
  items,
  onItemSelect,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
  menuListId,
  menuListAriaLabel = 'Options',
  paperSx,
  paperClassName,
  header,
  reserveIconSpace = false,
  listClassName,
  scrollToItemId,
  hideBackdrop = false,
  restoreFocusOnClose = true,
}) {
  const listRef = useRef(null)
  useFloatingMenuFocusRestore(open, anchorEl, restoreFocusOnClose)
  useFloatingMenuScrollToItem(open, scrollToItemId, listRef, items)

  return (
    <FloatingMenuPopover
      open={Boolean(open && anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      hideBackdrop={hideBackdrop}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      header={header}
      paperClassName={paperClassName}
      paperSx={paperSx}
      listRef={listRef}
      menuListId={menuListId}
      menuListAriaLabel={menuListAriaLabel}
      listClassName={listClassName}
      entries={buildMenuEntries(items, { reserveIconSpace, onItemSelect, onClose })}
    />
  )
}

export default FloatingMenuPopup
